export default __webpack_public_path__ + "static/sOliverCase-MediumWeb-f2989f586a8efb5f68aec87217ec9dd6.woff2";